import React from "react";
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { StaticImage } from 'gatsby-plugin-image';
import '../../sass/components/flexibleModules/_components.leadershipSection.scss';
import linkedinBlue from '../../images/linkedin-blue.svg';
import linkedinBlack from '../../images/icon-linkedin-black.svg';

const LeadershipComponent = ({ data }) => {
    return (
        <div className="cp-genericLeadership" style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-genericLeadership__inner" style={{ maxWidth: `${data.maxWidth ? (data.maxWidth / 16 + "rem") : ""}`, margin: "0 auto" }}>
                {data.leadershipRepeaterFields &&
                    <>
                        {data.leadershipRepeaterFields.map((leaderSection, index) => (
                            <div className="cp-genericLeadership__section" key={index}>
                                <div className="cp-genericLeadership__section-top l--flex">
                                    {leaderSection.leadershipRepeaterFieldsHeader &&
                                        <h2 dangerouslySetInnerHTML={{ __html: leaderSection.leadershipRepeaterFieldsHeader }} />
                                    }
                                    {leaderSection.leadershipRepeaterFieldsTeaser &&
                                        <p dangerouslySetInnerHTML={{ __html: leaderSection.leadershipRepeaterFieldsTeaser }} />
                                    }
                                </div>
                                <div className="cp-genericLeadership__section-bottom l--flex">
                                    {leaderSection.leadershipRepeaterFieldsSections &&
                                        <>
                                            {leaderSection.leadershipRepeaterFieldsSections.map((leaders, index) => (
                                                <a className="l--leader" href={leaders.leaderLinkedinLink} target="_blank" rel="noreferrer" key={index}>
                                                    <span className="l--leader__overlay">
                                                        {leaders.leaderThumb &&
                                                            <GatsbyImage image={getImage(leaders.leaderThumb.gatsbyImage)} alt={leaders.leaderThumb.altText} />
                                                        }
                                                        <div className="l--leader__overlay-hover">
                                                            {leaders.leaderBio &&
                                                                <p dangerouslySetInnerHTML={{ __html: leaders.leaderBio }} />
                                                            }
                                                            <img loading="lazy" src={linkedinBlue} alt="LinkedIn" />
                                                        </div>
                                                    </span>
                                                    <span className="l--leader__details l--flex">
                                                        <span>
                                                            {leaders.leaderName &&
                                                                <h5 className="l--leader__name">{leaders.leaderName}</h5>
                                                            }
                                                            {leaders.leaderTitle &&
                                                                <p className="l--leader__title">{leaders.leaderTitle}</p>
                                                            }
                                                        </span>
                                                        <img loading="lazy" src={linkedinBlack} alt="LinkedIn" />
                                                    </span>
                                                    {leaders.leaderBio &&
                                                        <p className="l-mobileOnly" dangerouslySetInnerHTML={{ __html: leaders.leaderBio }} />
                                                    }
                                                </a>
                                            ))}
                                        </>
                                    }
                                </div>
                            </div>
                        ))}
                    </>
                }
            </div>
        </div>
    );
}

export default LeadershipComponent;